export default class Content {
	_container: HTMLDivElement;

	constructor() {
		this._container = Mapy.Util.node("div") as HTMLDivElement;
	}

	// eslint-disable-next-line class-methods-use-this
	destroy() {}

	// eslint-disable-next-line class-methods-use-this
	show() {}

	// eslint-disable-next-line class-methods-use-this
	hide() {}

	get node() {
		return this._container;
	}
}
